<template lang="html">
  <div  :style="{ 'padding-top': offsetHeight + 'px' }">
  <!-- <div  :style="{ 'padding-top': 100 + 'px' }"> -->
    <van-nav-bar
      :fixed="true"
      title="已兑换私房课"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      ref="navBar"
    />
    <div>已兑换私房课</div>
    <!-- <gift-card-list
      ref="giftCardList"
      :slug="slug"
      buyer="me"
    /> -->
  </div>
</template>

<script>
  import Vue from 'vue'
  import { NavBar } from 'vant'
  import { Notify } from 'vant'
  // import GiftCardList from '../../gift-card-list.vue'
  Vue.use(NavBar)
  Vue.use(Notify)
  export default {
    components: {
      // GiftCardList
    },
    data () {
      return {
        slug: '',
        offsetHeight: 0
      }
    },
    methods: {
      onClickLeft() {
        this.$router.replace({
          name: `PersonalIndex`,
          params: {
            slug: this.slug
          }
        })
      }
    },
    mounted () {
      this.slug = this.$route.params.slug,
      this.$nextTick(function() {
        // this.offsetHeight = this.$refs.navBar.offsetHeight
        this.offsetHeight = this.$refs.navBar.$el.offsetHeight
      })
    }
  }
</script>

<style lang="css" scoped>
</style>
